import React from "react";
import TaskTemplateVisualStore from "../stores/TaskTemplatesVisualStore";
import { Form, FormInstance, Input } from "antd";
import { observer } from "mobx-react-lite";
import { Editor } from "@progress/kendo-react-editor";
import { AdvancedToolbar } from "../../common/components/EditorToolbar";
import AppModal from "../../common/components/AppModal";

type Props = {
    store: TaskTemplateVisualStore;
    parentForm: FormInstance;
    addCallback: (value: unknown) => void;
};

const SubtaskTemplateDialog: React.FC<Props> = ({
    store,
    parentForm,
    addCallback,
}) => {
    const [form] = Form.useForm();

    React.useEffect(() => {
        if (!store.selectedSubtaskTemplate) {
            form.resetFields();
        } else {
            form.setFieldsValue(store.selectedSubtaskTemplate.model);
        }
    }, [store.selectedSubtaskTemplate, form]);

    const handleSubmit = () => {
        form.validateFields().then(() => {
            const formData = form.getFieldsValue();

            if (store.selectedSubtaskTemplate?.index !== undefined) {
                const { subTasks } = parentForm.getFieldsValue();
                subTasks[store.selectedSubtaskTemplate?.index] = formData;
                parentForm.setFieldsValue({ subTasks });
            } else {
                addCallback(formData);
            }

            form.resetFields();
            store.setSelectedSubtaskTemplate(undefined);
        });
    };

    return (
        <AppModal
            data-id-type="modal-window"
            data-id-name="edit-subtask-template"
            className="alpha-modal"
            title="Subtask template"
            open={store.selectedSubtaskTemplate !== undefined}
            closable={false}
            centered
            width={574}
            cancelButtonTitle="Cancel"
            onCancelClick={() => {
                store.setSelectedSubtaskTemplate(undefined);
            }}
            cancelButtonProps={{
                "data-id": "button-edit-subtask-template-cancel",
                size: undefined,
            }}
            submitButtonTitle="Save"
            submitButtonProps={{
                "data-id": "button-edit-subtask-template-save",
                className: "dark",
                form: "edit-subtask-template-form",
                size: undefined,
            }}
        >
            <Form
                form={form}
                className="alpha-form"
                id="edit-subtask-template-form"
                layout="vertical"
                onFinish={handleSubmit}
                initialValues={store.selectedSubtaskTemplate?.model}
            >
                <Form.Item
                    name="title"
                    colon={false}
                    className="dialog-field"
                    label={<span className="dialog-field-label">Title</span>}
                    rules={[{ required: true, message: "Title is required" }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name="description"
                    colon={false}
                    className="dialog-field"
                    style={{ marginBottom: 5 }}
                    label={
                        <span className="dialog-field-label">Description</span>
                    }
                    getValueProps={(value) => ({ value: value ?? "" })}
                >
                    <Editor
                        tools={AdvancedToolbar}
                        contentStyle={{ height: 150, fontSize: 14 }}
                        defaultEditMode="div"
                        onChange={(e) =>
                            form.setFieldValue("description", e.html)
                        }
                    />
                </Form.Item>
            </Form>
        </AppModal>
    );
};

export default observer(SubtaskTemplateDialog);
